export let IS_NATIVE = false;
export const MAX_TIMESTAMP = 16732543783000;
export const MAX_CONV = 20;
export const IMG_EMPTY = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";